import { actionsPreprocessor } from '@/utils/redux';

const actionNames = [
  'SEND_INVITE',
  'SEND_INVITE_SUCCESS',
  'SEND_INVITE_FAILED',

  'FETCH_INVITES',
  'FETCH_INVITES_SUCCESS',
  'FETCH_INVITES_FAILED',

  'FETCH_TOKEN_DATA',
  'FETCH_TOKEN_DATA_SUCCESS',
  'FETCH_TOKEN_DATA_FAILED',

  'TABLE_CHANGE',
];

const { actions, actionTypes } = actionsPreprocessor('invite', actionNames);

export default actions;
export { actionTypes };
